import ItemCard from "@affinity/components/ItemCard/ItemCard";
import { colours } from "@affinity/constants/StyleConstants";
import { breakpointWidth, rem } from "@affinity/constants/StyleHelpers";
import Icon from "@insite/mobius/Icon";
import * as React from "react";
import styled from "styled-components";

export const AddAdressButton = (props: React.ButtonHTMLAttributes<HTMLButtonElement>) => {
    return (
        <StyledButton {...props}>
            <ItemCard.Title>Add a different address </ItemCard.Title>
            <StyledIcon src="PlusCircle" />
        </StyledButton>
    );
};

const StyledButton = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 5px;
    button-style: none;
    border: 2px solid ${colours.lightBlue};
    border-left: 5px solid ${colours.lightBlue};
    background: ${colours.white};
    text-align: left;

    padding: ${rem(20)};
    gap: ${rem(10)};
    @media (min-width: ${breakpointWidth("lg")}) {
        padding: ${rem(30)};
        border-radius: 8px;
        border-left: 8px solid ${colours.lightBlue};
    }
`;

const StyledIcon = styled(Icon)`
    width: auto;
    height: auto;
    svg {
        width: ${rem(44)};
        height: ${rem(44)};
        stroke-width: 1px;
        stroke: ${colours.darkBlue};
        fill: ${colours.lightBlue};
    }
`;
